import template from './expandableTable.html';
import controller from './expandableTableCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    options: '<',
    loanList: '<',
    loanDetailScope: '<',
    lendingDetailScope: '<',
  },
};
